"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendTosConsent = void 0;
class SendTosConsent {
    constructor(accountService) {
        this.accountService = accountService;
    }
    execute(request) {
        return this.accountService.sendTosConsent(request);
    }
}
exports.SendTosConsent = SendTosConsent;
